// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsMenu-cls1_Vr7","cls2":"ToolsMenu-cls2_zj9 ToolsMenu-cls1_Vr7"};